export default __webpack_public_path__ + "static/media/Close.4665a6ca.svg";